import React from 'react';

const Pagination = ({
  listsPerPage,
  totalLists,
  handlePageChange,
  currentPage
}) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalLists / listsPerPage); i++) {
    pageNumbers.push(i);
  }

  const indexOfCurrentPage = pageNumbers.indexOf(currentPage);

  let startPage, endPage;
  if (pageNumbers.length < 5) {
    startPage = 0;
    endPage = pageNumbers.length;
  } else {
    if (indexOfCurrentPage < 2) {
      startPage = 0;
      endPage = 5;
    } else if (indexOfCurrentPage >= pageNumbers.length - 2) {
      startPage = pageNumbers.length - 5;
      endPage = pageNumbers.length;
    } else {
      startPage = indexOfCurrentPage - 2;
      endPage = indexOfCurrentPage + 3;
    }
  }

  const visiblePageNumbers = pageNumbers.slice(startPage, endPage);
  const previousPage = currentPage - 1 !== 0 ? currentPage - 1 : currentPage;
  const nextPage =
    currentPage + 1 <= pageNumbers.length ? currentPage + 1 : currentPage;
  return (
    <div className='card-footer py-3'>
      <nav className='py-3' aria-label='...'>
        <ul className='pagination justify-content-end mb-0'>
          <li className='page-item'>
            <div className='page-link' onClick={ () => handlePageChange(1) }>
              <i className='fas fa-angle-left' />
              <i className='fas fa-angle-left' />
            </div>
          </li>
          <li className='page-item'>
            <div
              className='page-link'
              onClick={ () => handlePageChange(previousPage) }
            >
              <i className='fas fa-angle-left' />
            </div>
          </li>
          {visiblePageNumbers.map(visiblePageNumber => (
            <li
              className={ `page-item ${
                visiblePageNumber === currentPage ? 'active' : ''
              }` }
              key={ visiblePageNumber }
            >
              <div
                onClick={ () => handlePageChange(visiblePageNumber) }
                className='page-link'
              >
                {visiblePageNumber}
              </div>
            </li>
          ))}
          <li className='page-item'>
            <div className='page-link' onClick={ () => handlePageChange(nextPage) }>
              <i className='fas fa-angle-right' />
            </div>
          </li>
          <li className='page-item'>
            <div
              className='page-link'
              onClick={ () => handlePageChange(pageNumbers.length) }
            >
              <i className='fas fa-angle-right' />
              <i className='fas fa-angle-right' />
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
